import { WORLD_SIZE } from "./WORLD_SIZE";

// Вид карты: точка сцены (x, y) на экране — `(ox + scale·x, oy + scale·y)` в CSS-пикселях
// (у повёрнутой карты — от повёрнутой точки).
export type MapView = { scale: number; ox: number; oy: number };

// Карта целиком с полями, по центру области `width × height`.
export const fitView = (width: number, height: number): MapView => {
  const scale = Math.min(width, height) / (WORLD_SIZE * 1.08);
  return {
    scale,
    ox: width / 2 - (WORLD_SIZE / 2) * scale,
    oy: height / 2 - (WORLD_SIZE / 2) * scale,
  };
};

// Приближение в `factor` раз вокруг точки экрана (px, py) в пределах `min`–`max` масштаба.
export const zoomAt = (
  view: MapView,
  factor: number,
  px: number,
  py: number,
  min: number,
  max: number,
): MapView => {
  const scale = Math.max(min, Math.min(max, view.scale * factor));
  const k = scale / view.scale;
  return { scale, ox: px - (px - view.ox) * k, oy: py - (py - view.oy) * k };
};

// Сдвиг в пределах: карта больше области — её край не заходит внутрь дальше `pad`; меньше —
// она не уходит за край области больше чем на `pad`. Так карту нельзя потерять.
export const clampView = (view: MapView, width: number, height: number): MapView => {
  const size = view.scale * WORLD_SIZE;
  const pad = Math.min(width, height) * 0.1;
  const clamp = (offset: number, span: number) =>
    Math.max(Math.min(span - size, 0) - pad, Math.min(Math.max(span - size, 0) + pad, offset));
  return { ...view, ox: clamp(view.ox, width), oy: clamp(view.oy, height) };
};
